export function arrayRemove (arr, i) {
  if (delete arr[i]) {
    return arr.filter((x) => typeof (x) !== 'undefined')
  } else {
    throw new Error('Out of bound index')
  }
}

export function arrayMoveUp (arr, i) {
  const c = arr[i]
  if (i > 0) {
    arr[i] = arr[i - 1]
    arr[i - 1] = c
  }
  return Array.from(arr)
}

export function arrayMoveDown (arr, i) {
  const c = arr[i]
  if (i < arr.length - 1) {
    arr[i] = arr[i + 1]
    arr[i + 1] = c
  }
  return Array.from(arr)
}



// WEBPACK FOOTER //
// ./src/helpers/array.js